import { ConsumerLoanParameter } from './ConsumerLoanParameter';

export const enum ConsumerLoanTargetPath {
    calculator = `/:${ConsumerLoanParameter.locale}`,
    init = `/:${ConsumerLoanParameter.locale}/init`,
    application = `/:${ConsumerLoanParameter.locale}/app`,
    apply = `/:${ConsumerLoanParameter.locale}/apply`,
    callback = `/:${ConsumerLoanParameter.locale}/app/:${ConsumerLoanParameter.applicationReferenceNumber}/callback`,
    ongoing = `/:${ConsumerLoanParameter.locale}/app/:${ConsumerLoanParameter.applicationReferenceNumber}`,
    coapplicant = `/:${ConsumerLoanParameter.locale}/app/:${ConsumerLoanParameter.applicationReferenceNumber}/coapplicant`,
    error = `/:${ConsumerLoanParameter.locale}/err`,
    logout = `/:${ConsumerLoanParameter.locale}/logout`,
    consent = `/:${ConsumerLoanParameter.locale}/consent`,
    coapplicantInit = `/:${ConsumerLoanParameter.locale}/app/:${ConsumerLoanParameter.applicationReferenceNumber}/coapplicant/init`,
    draftInit = `/:${ConsumerLoanParameter.locale}/draft/:${ConsumerLoanParameter.applicationReferenceNumber}/main/init`,
    draft = `/:${ConsumerLoanParameter.locale}/draft/:${ConsumerLoanParameter.applicationReferenceNumber}/main`,
    coapplicantDraftInit = `/:${ConsumerLoanParameter.locale}/draft/:${ConsumerLoanParameter.applicationReferenceNumber}/co/init`,
    coapplicantDraft = `/:${ConsumerLoanParameter.locale}/draft/:${ConsumerLoanParameter.applicationReferenceNumber}/co`,
}
